module.exports = "https://www.gc-qa.gnp.com.mx/169adb59e7763dbb35da2d13c5a9aee6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-upload.svg
// module id = 8131
// module chunks = 0